export default __webpack_public_path__ + "static/media/logo-brmtools.74b1407e.webp";